module.exports = __webpack_public_path__ + "media/images/front/sp_tl-menu-0278c77be7f5effcc9c47a16009487e8.png";